import bozjaSouthernMap from './bozjasouthern.png';
import { EurekaZoneInfo } from './eureka';

// https://xivapi.com/search?indexes=Fate&filters=ID%3E=1597,ID%3C=1628&columns=Description,Name,Url

export const zoneInfoBozjaSouthern: EurekaZoneInfo = {
  mapImage: bozjaSouthernMap,
  mapWidth: 1600,
  mapHeight: 1400,
  shortName: 'bozjasouthern',
  hasTracker: false,
  onlyShowInactiveWithExplicitRespawns: true,
  treatNMsAsSkirmishes: true,
  mapToPixelXScalar: 47.911,
  mapToPixelXConstant: -292.56,
  mapToPixelYScalar: 48.938,
  mapToPixelYConstant: -349.22,
  fieldNotes: [
    {
      id: 1,
      name: {
        en: 'Bajsaljen Ulgasch',
        de: 'Bajsaljen Ulgasch',
        fr: 'Bajsaljen Ulgasch',
        ja: 'バイシャーエン・ウルガッシュ',
        cn: '白沙恩·乌尔嘉失',
        ko: '바이샤엔 울가쉬',
        tc: '白沙恩·烏爾嘉失',
      },
      shortName: {
        en: 'Bajsalen',
        de: 'Bajsaljen',
        fr: 'Bajsaljen',
        ja: 'バイシャーエン',
        cn: '白沙恩',
        ko: '바이샤엔',
        tc: '白沙恩',
      },
      rarity: 1,
    },
    {
      id: 2,
      name: {
        en: 'Marsak Apella',
        de: 'Marsak Apella',
        fr: 'Marsak Apella',
        ja: 'マルシャーク・アペッラ',
        cn: '马尔夏克·亚佩拉',
        ko: '마르샤크 아펠라',
        tc: '馬爾夏克·亞佩拉',
      },
      shortName: {
        en: 'Marsak',
        de: 'Marsak',
        fr: 'Marsak',
        ja: 'マルシャーク',
        cn: '马尔夏克',
        ko: '마르샤크',
        tc: '馬爾夏克',
      },
      rarity: 1,
    },
    {
      id: 3,
      name: {
        en: 'Xeven Svanasch',
        de: 'Xeven Svanasch',
        fr: 'Xeven Svanasch',
        ja: 'ゼヴェン・スヴァナシュ',
        cn: '泽文·斯瓦楠失',
        ko: '제벤 스바나쉬',
        tc: '澤文·斯瓦楠失',
      },
      shortName: {
        en: 'Xeven',
        de: 'Xeven',
        fr: 'Xeven',
        ja: 'ゼヴェン',
        cn: '泽文',
        ko: '제벤',
        tc: '澤文',
      },
      rarity: 1,
    },
    {
      id: 4,
      name: {
        en: 'Isolde Covey',
        de: 'Isolde Covey',
        fr: 'Isolde Covey',
        ja: 'イソルデ・コヴィー',
        cn: '伊索尔德·科维',
        ko: '이솔데 코비',
        tc: '伊索德·科維',
      },
      shortName: {
        en: 'Isolde',
        de: 'Isolde',
        fr: 'Isolde',
        ja: 'イソルデ',
        cn: '伊索尔德',
        ko: '이솔데',
        tc: '伊索德',
      },
      rarity: 2,
    },
    {
      id: 5,
      name: {
        en: 'Stanik Alubov',
        de: 'Stanik Alubov',
        fr: 'Stanik Alubov',
        ja: 'スタニック・アルボフ',
        cn: '斯塔尼克·亚柳波芙',
        ko: '스타니크 알루보프',
        tc: '斯塔尼克·亞柳波芙',
      },
      shortName: {
        en: 'Stanik',
        de: 'Stanik',
        fr: 'Stanik',
        ja: 'スタニック',
        cn: '斯塔尼克',
        ko: '스타니크',
        tc: '斯塔尼克',
      },
      rarity: 1,
    },
    {
      id: 6,
      name: {
        en: 'Blaz Azetina',
        de: 'Blaz Azetina',
        fr: 'Blaz Azetina',
        ja: 'ブラズ・アゼティナ',
        cn: '布拉兹·亚泽缇娜',
        ko: '블라즈 아제티나',
        tc: '布拉茲·亞澤緹娜',
      },
      shortName: {
        en: 'Blaz',
        de: 'Blaz',
        fr: 'Blaz',
        ja: 'ブラズ',
        cn: '布拉兹',
        ko: '블라즈',
        tc: '布拉茲',
      },
      rarity: 3,
    },
    {
      id: 7,
      name: {
        en: 'Velibor Azetina',
        de: 'Velibor Azetina',
        fr: 'Velibor Azetina',
        ja: 'ヴェリボル・アゼティナ',
        cn: '韦利博尔·亚泽缇娜',
        ko: '벨리보르 아제티나',
        tc: '韋利博爾·亞澤緹娜',
      },
      shortName: {
        en: 'Velibor',
        de: 'Velibor',
        fr: 'Velibor',
        ja: 'ヴェリボル',
        cn: '韦利博尔',
        ko: '벨리보르',
        tc: '韋利博爾',
      },
      rarity: 3,
    },
    {
      id: 8,
      name: {
        en: 'Aggie Glover',
        de: 'Aggie Glover',
        fr: 'Aggie Glover',
        ja: 'アギー・グローヴァー',
        cn: '阿姬·格洛弗',
        ko: '애지 글러버',
        tc: '阿姬·格洛弗',
      },
      shortName: {
        en: 'Aggie',
        de: 'Aggie',
        fr: 'Aggie',
        ja: 'アギー',
        cn: '阿姬',
        ko: '애지',
        tc: '阿姬',
      },
      rarity: 1,
    },
    {
      id: 9,
      name: {
        en: 'Llofii pyr Potitus',
        de: 'Llofii pyr Potitus',
        fr: 'Llofii pyr Potitus',
        ja: 'ロフィー・ピル・ポティトゥス',
        cn: '罗菲·皮尔·珀提图斯',
        ko: '로피 피르 포티투스',
        tc: '羅菲·皮爾·珀提圖斯',
      },
      shortName: {
        en: 'Llofii',
        de: 'Llofii',
        fr: 'Llofii',
        ja: 'ロフィー',
        cn: '罗菲',
        ko: '로피',
        tc: '羅菲',
      },
      rarity: 2,
    },
    {
      id: 10,
      name: {
        en: 'Hernais pyr Longus',
        de: 'Hernais pyr Longus',
        fr: 'Hernais pyr Longus',
        ja: 'エルネイス・ピル・ロングス',
        cn: '艾尔内斯·皮尔·隆古斯',
        ko: '에르네이스 피르 롱구스',
        tc: '艾爾內斯·皮爾·隆古斯',
      },
      shortName: {
        en: 'Hernais',
        de: 'Hernais',
        fr: 'Hernais',
        ja: 'エルネイス',
        cn: '艾尔内斯',
        ko: '에르네이스',
        tc: '艾爾內斯',
      },
      rarity: 3,
    },
    {
      id: 11,
      name: {
        en: 'Dabog aan Inivisch',
        de: 'Dabog aan Inivisch',
        fr: 'Dabog aan Inivisch',
        ja: 'ダボグ・アン・イニヴァシュ',
        cn: '达波格·安·因尼维失',
        ko: '다보그 안 이니비쉬',
        tc: '達波格·安·因尼維失',
      },
      shortName: {
        en: 'Dabog',
        de: 'Dabog',
        fr: 'Dabog',
        ja: 'ダボグ',
        cn: '达波格',
        ko: '다보그',
        tc: '達波格',
      },
      rarity: 5,
    },
    {
      id: 12,
      name: {
        en: 'Dyunbu pyr Potitus',
        de: 'Dyunbu pyr Potitus',
        fr: 'Dyunbu pyr Potitus',
        ja: 'ユンブ・ピル・ポティトゥス',
        cn: '尤恩布·皮尔·珀提图斯',
        ko: '윤부 피르 포티투스',
        tc: '尤恩布·皮爾·珀提圖斯',
      },
      shortName: {
        en: 'Dyunbu',
        de: 'Dyunbu',
        fr: 'Dyunbu',
        ja: 'ユンブ',
        cn: '尤恩布',
        ko: '윤부',
        tc: '尤恩布',
      },
      rarity: 4,
    },
    {
      id: 13,
      name: {
        en: 'Clarricie quo Priscus',
        de: 'Clarricie quo Priscus',
        fr: 'Clarricie quo Priscus',
        ja: 'クラリシー・クォ・プリスクス',
        cn: '克拉莉西·库奥·普利斯克斯',
        ko: '클라리시 쿠오 프리스쿠스',
        tc: '克拉莉西·庫奧·普利斯克斯',
      },
      shortName: {
        en: 'Clarricie',
        de: 'Clarricie',
        fr: 'Clarricie',
        ja: 'クラリシー',
        cn: '克拉莉西',
        ko: '클라리시',
        tc: '克拉莉西',
      },
      rarity: 2,
    },
    {
      id: 14,
      name: {
        en: 'Sartauvoir quo Soranus',
        de: 'Sartauvoir quo Soranus',
        fr: 'Sartauvoir quo Soranus',
        ja: 'サルトヴォアール・クォ・ソラノス',
        cn: '萨托瓦尔·库奥·索拉努斯',
        ko: '사르토부아르 쿠오 소라누스',
        tc: '薩托瓦爾·庫奧·索拉努斯',
      },
      shortName: {
        en: 'Sartauvoir',
        de: 'Sartauvoir',
        fr: 'Sartauvoir',
        ja: 'サルトヴォアール',
        cn: '萨托瓦尔',
        ko: '사르토부아르',
        tc: '薩托瓦爾',
      },
      rarity: 5,
    },
    {
      id: 15,
      name: {
        en: 'Sicinius mal Vellutus',
        de: 'Sicinius mal Vellutus',
        fr: 'Sicinius mal Vellutus',
        ja: 'シシニアス・マル・ヴェリュータス',
        cn: '西西尼乌斯·玛尔·维琉图斯',
        ko: '시시니우스 말 벨루투스',
        tc: '西西尼烏斯·瑪爾·維琉圖斯',
      },
      shortName: {
        en: 'Sicinius',
        de: 'Sicinius',
        fr: 'Sicinius',
        ja: 'シシニアス',
        cn: '西西尼乌斯',
        ko: '시시니우스',
        tc: '西西尼烏斯',
      },
      rarity: 3,
    },
    {
      id: 16,
      name: {
        en: 'Sadr rem Albeleo',
        de: 'Sadr rem Albeleo',
        fr: 'Sadr rem Albeleo',
        ja: 'サドル・レム・アルビレオ',
        cn: '萨德尔·雷姆·阿尔贝雷欧',
        ko: '사드르 렘 알비레오',
        tc: '薩德爾·雷姆·阿爾貝雷歐',
      },
      shortName: {
        en: 'Albeleo',
        de: 'Albeleo',
        fr: 'Albeleo',
        ja: 'アルビレオ',
        cn: '阿尔贝雷欧',
        ko: '알비레오',
        tc: '阿爾貝雷歐',
      },
      rarity: 3,
    },
    {
      id: 17,
      name: {
        en: 'Lyon rem Helsos',
        de: 'Lyon rem Helsos',
        fr: 'Lyon rem Helsos',
        ja: 'ライアン・レム・ヘルソス',
        cn: '莱昂·雷姆·赫尔索斯',
        ko: '라이언 렘 헬소스',
        tc: '萊昂·雷姆·赫爾索斯',
      },
      shortName: {
        en: 'Lyon',
        de: 'Lyon',
        fr: 'Lyon',
        ja: 'ライアン',
        cn: '莱昂',
        ko: '라이언',
        tc: '萊昂',
      },
      rarity: 5,
    },
    {
      id: 18,
      name: {
        en: 'Menenius sas Lanatus',
        de: 'Menenius sas Lanatus',
        fr: 'Menenius sas Lanatus',
        ja: 'メネニウス・サス・ラナトゥス',
        cn: '梅内纽斯·萨斯·拉那图斯',
        ko: '메네니우스 사스 라나투스',
        tc: '梅內紐斯·薩斯·拉那圖斯',
      },
      shortName: {
        en: 'Menenius', // FIX-ME
        de: 'Menenius',
        fr: 'Menenius',
        ja: 'メネニウス',
        cn: '梅内纽斯',
        ko: '메네니우스',
        tc: '梅內紐斯',
      },
      rarity: 3,
    },
    {
      id: 19,
      name: {
        en: 'Misija Votyasch',
        de: 'Misija Votyasch',
        fr: 'Misija Votyasch',
        ja: 'ミーシィヤ・ヴォートヤシュ',
        cn: '米希亚·博特雅失',
        ko: '미시야 보트야쉬',
        tc: '米希亞·博特雅失',
      },
      shortName: {
        en: 'Misija', // FIX-ME
        de: 'Misija',
        fr: 'Misija',
        ja: 'ミーシィヤ',
        cn: '米希亚',
        ko: '미시야',
        tc: '米希亞',
      },
      rarity: 3,
    },
    {
      id: 20,
      name: {
        en: 'Gunnhildr',
        de: 'Gunnhildr',
        fr: 'Gunnhildr',
        ja: 'グンヒルド',
        cn: '贡希尔德',
        ko: '군힐드',
        tc: '貢希爾德',
      },
      shortName: {
        en: 'Gunnhildr',
        de: 'Gunnhildr',
        fr: 'Gunnhildr',
        ja: 'グンヒルド',
        cn: '贡希尔德',
        ko: '군힐드',
        tc: '貢希爾德',
      },
      rarity: 3,
    },
    {
      id: 21,
      name: {
        en: 'Lilja Sjasaris',
        de: 'Lilja Sjasaris',
        fr: 'Lilja Sjasaris',
        ja: 'リリヤ・シアサリス',
        cn: '莉莉娅·希雅萨里斯',
        ko: '리리야 샤사리스',
        tc: '莉莉婭·希雅薩里斯',
      },
      shortName: {
        en: 'Lilja Sjasaris', // FIX-ME
        de: 'Lilja',
        fr: 'Lilja',
        ja: 'リリヤ',
        cn: '莉莉娅',
        ko: '리리야',
        tc: '莉莉婭',
      },
      rarity: 3,
    },
    {
      id: 22,
      name: {
        en: 'Bwagi Ennze Panca',
        de: 'Bwagi Ennze Panca',
        fr: 'Bwagi Ennze Panca',
        ja: 'ブワジ・エンゼ・パンチャ',
        cn: '布瓦基·恩泽·潘卡',
        ko: '브와기 엔제 판카',
        tc: '布瓦基·恩澤·潘卡',
      },
      shortName: {
        en: 'Bwagi Ennze Panca', // FIX-ME
        de: 'Bwagi',
        fr: 'Bwagi',
        ja: 'ブワジ',
        cn: '布瓦基',
        ko: '브와기',
        tc: '布瓦基',
      },
      rarity: 3,
    },
    {
      id: 23,
      name: {
        en: 'Rostik Liubasch',
        de: 'Rostik Liubasch',
        fr: 'Rostik Liubasch',
        ja: 'ロスティック・リュバシュ',
        cn: '罗斯提克·琉芭失',
        ko: '로스틱 리우바쉬',
        tc: '羅斯提克·琉芭失',
      },
      shortName: {
        en: 'Rostik Liubasch', // FIX-ME
        de: 'Rostik',
        fr: 'Rostik',
        ja: 'ロスティック',
        cn: '罗斯提克',
        ko: '로스틱',
        tc: '羅斯提克',
      },
      rarity: 3,
    },
    {
      id: 24,
      name: {
        en: 'Mikoto Jinba',
        de: 'Mikoto',
        fr: 'Mikoto Jinba',
        ja: 'ミコト・ジンバ',
        cn: '神庭水琴',
        ko: '미코토 진바',
        tc: '神庭水琴',
      },
      shortName: {
        en: 'Mikoto Jinba', // FIX-ME
        de: 'Mikoto',
        fr: 'Mikoto',
        ja: 'ミコト',
        cn: '水琴',
        ko: '미코토',
        tc: '水琴',
      },
      rarity: 3,
    },
    {
      id: 25,
      name: {
        en: 'Misija Votyasch',
        de: 'Misija Votyasch',
        fr: 'Misija Votyasch',
        ja: 'ミーシィヤ・ヴォートヤシュ',
        cn: '米希亚·博特雅失',
        ko: '미시야 보트야쉬',
        tc: '米希亞·博特雅失',
      },
      shortName: {
        en: 'Misija Votyasch', // FIX-ME
        de: 'Misija',
        fr: 'Misija',
        ja: 'ミーシィヤ',
        cn: '米希亚',
        ko: '미시야',
        tc: '米希亞',
      },
      rarity: 3,
    },
    {
      id: 26,
      name: {
        en: 'Gunnhildr',
        de: 'Gunnhildr',
        fr: 'Gunnhildr',
        ja: 'グンヒルド',
        cn: '贡希尔德',
        ko: '군힐드',
        tc: '貢希爾德',
      },
      shortName: {
        en: 'Gunnhildr',
        de: 'Gunnhildr',
        fr: 'Gunnhildr',
        ja: 'グンヒルド',
        cn: '贡希尔德',
        ko: '군힐드',
        tc: '貢希爾德',
      },
      rarity: 3,
    },
    {
      id: 27,
      name: {
        en: 'Trinity Seeker',
        de: 'Trinität der Sucher',
        fr: 'Trinité soudée',
        ja: 'トリニティ・シーカー',
        cn: '求道之三位一体',
        ko: '탐구의 삼위일체',
        tc: '求道之三位一體',
      },
      shortName: {
        en: 'Seeker', // FIX-ME
        de: 'Sucher',
        fr: 'Soudée',
        ja: 'シーカー',
        cn: '求道之三位一体',
        ko: '탐구의 삼위일체',
        tc: '求道之三位一體',
      },
      rarity: 4,
    },
    {
      id: 28,
      name: {
        en: 'Queen\'s Guard',
        de: 'Die Königinnenwache',
        fr: 'Garde-la-Reine',
        ja: 'クイーンズ・ガード',
        cn: '女王护卫',
        ko: '여왕의 근위병',
        tc: '女王護衛',
      },
      shortName: {
        en: 'Guard', // FIX-ME
        de: 'Königinnenwache',
        fr: 'Garde',
        ja: 'ガード',
        cn: '女王护卫',
        ko: '여왕의 근위병',
        tc: '女王護衛',
      },
      rarity: 4,
    },
    {
      id: 29,
      name: {
        en: 'Trinity Avowed',
        de: 'Trinität der Eingeschworenen',
        fr: 'Trinités féale',
        ja: 'トリニティ・アヴァウド',
        cn: '誓约之三位一体',
        ko: '맹세의 삼위일체',
        tc: '誓約之三位一體',
      },
      shortName: {
        en: 'Trinity Avowed', // FIX-ME
        de: 'Eingeschworene',
        fr: 'Féale',
        ja: 'アヴァウド',
        cn: '誓约之三位一体',
        ko: '맹세의 삼위일체',
        tc: '誓約之三位一體',
      },
      rarity: 4,
    },
    {
      id: 30,
      name: {
        en: 'Save the Queen',
        de: 'Die heilige Klinge',
        fr: 'Sauver la Reine',
        ja: 'セイブ・ザ・クイーン',
        cn: '天佑女王',
        ko: '세이브 더 퀸',
        tc: '天佑女王',
      },
      shortName: {
        en: 'Save the Queen', // FIX-ME
        de: 'Heilige Klinge',
        fr: 'Sauver',
        ja: 'セイブ・ザ・クイーン',
        cn: '天佑女王',
        ko: '세이브 더 퀸',
        tc: '天佑女王',
      },
      rarity: 5,
    },
  ],
  nms: {
    sneak: {
      label: {
        en: 'Sneak & Spell',
        de: 'Taktisches Gemetzel',
        fr: 'Les yeux de l\'ennemi',
        ja: '術士大隊との会敵',
        cn: '遭遇术师大队',
        ko: '술사대대 발견',
        tc: '遭遇術師大隊',
      },
      shortLabel: {
        en: 'Sneak',
        de: 'Gemetzel',
        fr: 'Yeux',
        ja: '術士大隊との会敵',
        cn: '遭遇术师大队',
        ko: '술사대대 발견',
        tc: '遭遇術師大隊',
      },
      x: 20.3,
      y: 26.8,
      fateId: 1597,
    },
    robots: {
      label: {
        en: 'None of Them Knew They Were Robots',
        de: 'Nichts als Schrott',
        fr: 'Les araignées de fer',
        ja: '無人魔導兵器との会敵',
        cn: '遭遇无人魔导兵器',
        ko: '무인 마도 병기 발견',
        tc: '遭遇無人魔導兵器',
      },
      fieldNotes: 8,
      shortLabel: {
        en: 'Robots',
        de: 'Schrott',
        fr: 'Araignées',
        ja: '無人魔導兵器との会敵',
        cn: '遭遇无人魔导兵器',
        ko: '무인 마도 병기 발견',
        tc: '遭遇無人魔導兵器',
      },
      x: 24.8,
      y: 27.5,
      fateId: 1598,
    },
    beasts: {
      label: {
        en: 'The Beasts Must Die',
        de: 'Husch, ins Körbchen!',
        fr: 'Museler le Chien',
        ja: '忠犬との遭遇',
        cn: '发现忠犬',
        ko: '충견과 조우하다',
        tc: '發現忠犬',
      },
      fieldNotes: 3,
      shortLabel: {
        en: 'Beasts',
        de: 'Körbchen',
        fr: 'Museler',
        ja: '忠犬との遭遇',
        cn: '发现忠犬',
        ko: '충견과 조우하다',
        tc: '發現忠犬',
      },
      x: 20.3,
      y: 26.8,
      fateId: 1599,
    },
    unrest: {
      label: {
        en: 'Unrest for the Wicked',
        de: 'Wer rastet, der blutet',
        fr: 'Pas de quartier',
        ja: '術士大隊への奇襲',
        cn: '奇袭术师大队',
        ko: '술사대대 기습',
        tc: '奇襲術師大隊',
      },
      shortLabel: {
        en: 'Unrest',
        de: 'Wer rastet..',
        fr: 'Pas de quartier',
        ja: '術士大隊への奇襲',
        cn: '奇袭术师大队',
        ko: '술사대대 기습',
        tc: '奇襲術師大隊',
      },
      x: 24.8,
      y: 27.5,
      fateId: 1600,
    },
    machine: {
      label: {
        en: 'More Machine Now Than Man',
        de: 'Auf zum Gegenangriff',
        fr: 'Machines aux trousses',
        ja: '有人魔導兵器の迎撃',
        cn: '迎击有人魔导兵器',
        ko: '유인 마도 병기 요격',
        tc: '迎擊有人魔導兵器',
      },
      isCEPrecursor: true,
      fieldNotes: 1,
      shortLabel: {
        en: 'Machine',
        de: 'Gegenangriff',
        fr: 'Machine',
        ja: '有人魔導兵器の迎撃',
        cn: '迎击有人魔导兵器',
        ko: '유인 마도 병기 요격',
        tc: '迎擊有人魔導兵器',
      },
      x: 28.4,
      y: 29.3,
      fateId: 1601,
    },
    plants: {
      label: {
        en: 'Can Carnivorous Plants Bloom Even on a Battlefield?',
        de: 'Linientreue um jeden Preis',
        fr: 'Des Racines et des Crocs',
        ja: '野生生物を排除せよ',
        cn: '排除野生生物',
        ko: '야생 생물을 제거하라',
        tc: '排除野生生物',
      },
      fieldNotes: 5,
      shortLabel: {
        en: 'Plants',
        de: 'Linientreue',
        fr: 'Racines',
        ja: '野生生物を排除せよ',
        cn: '排除野生生物',
        ko: '야생 생물을 제거하라',
        tc: '排除野生生物',
      },
      x: 34.4,
      y: 29.3,
      fateId: 1602,
    },
    seeq: {
      label: {
        en: 'Seeq and Destroy',
        de: 'Dem Rüpel seine Meute',
        fr: 'Ménagerie guerrière',
        ja: '豚面の魔獣使い',
        cn: '兽性兽心的驯兽师',
        ko: '시크족 마수 조련사',
        tc: '獸性獸心的馴獸師',
      },
      shortLabel: {
        en: 'Seeq',
        de: 'Rüpel',
        fr: 'Ménagerie',
        ja: '豚面の魔獣使い',
        cn: '兽性兽心的驯兽师',
        ko: '시크족 마수 조련사',
        tc: '獸性獸心的馴獸師',
      },
      x: 28.9,
      y: 26.1,
      fateId: 1603,
    },
    pets: {
      label: {
        en: 'All Pets are Off',
        de: 'Ungeheuerlich!',
        fr: 'Belles plantes',
        ja: '華麗なる珍獣使い',
        cn: '华丽魔女的珍兽使者',
        ko: '화려한 희귀마수 조련사',
        tc: '華麗魔女的珍獸使者',
      },
      isCEPrecursor: true,
      fieldNotes: 2,
      shortLabel: {
        en: 'Pets',
        de: 'Ungeheuerlich',
        fr: 'Plantes',
        ja: '華麗なる珍獣使い',
        cn: '华丽魔女的珍兽使者',
        ko: '화려한 희귀마수 조련사',
        tc: '華麗魔女的珍獸使者',
      },
      x: 17.3,
      y: 26.6,
      fateId: 1604,
    },
    firstlaw: {
      label: {
        en: 'Conflicting with the First Law',
        de: 'Schufter-10 wird verschrottet',
        fr: 'Que des numéros dix',
        ja: '労働十号破壊命令',
        cn: '破坏劳动十号',
        ko: '노동 10호 파괴 명령',
        tc: '破壞勞動十號',
      },
      fieldNotes: 4,
      shortLabel: {
        en: 'First Law',
        de: 'Schufter',
        fr: 'Numéros dix',
        ja: '労働十号破壊命令',
        cn: '破坏劳动十号',
        ko: '노동 10호 파괴 명령',
        tc: '破壞勞動十號',
      },
      x: 34.4,
      y: 29.3,
      fateId: 1605,
    },
    heal: {
      label: {
        en: 'Brought to Heal',
        de: 'Nächstenliebe, Nächstenhiebe',
        fr: 'Miséricorde impériale',
        ja: '恩徳の術士たち',
        cn: '施恩布德的术师队',
        ko: '은덕의 술사들',
        tc: '施恩布德的術師隊',
      },
      shortLabel: {
        en: 'Heal',
        de: 'Nächstenliebe',
        fr: 'Miséricorde',
        ja: '恩徳の術士たち',
        cn: '施恩布德的术师队',
        ko: '은덕의 술사들',
        tc: '施恩布德的術師隊',
      },
      x: 28.9,
      y: 26.1,
      fateId: 1606,
    },
    mash: {
      label: {
        en: 'The Monster Mash',
        de: 'Rache ist Blutwurst',
        fr: 'Le retour du chien fidèle',
        ja: '忠犬の逆襲',
        cn: '忠犬的逆袭',
        ko: '충견의 역습',
        tc: '忠犬的逆襲',
      },
      fieldNotes: 10,
      shortLabel: {
        en: 'Mash',
        de: 'Rache',
        fr: 'Retour du chien',
        ja: '忠犬の逆襲',
        cn: '忠犬的逆袭',
        ko: '충견의 역습',
        tc: '忠犬的逆襲',
      },
      x: 31.3,
      y: 22.0,
      fateId: 1607,
    },
    alert: {
      label: {
        en: 'Red Chocobo Alert',
        de: 'Großes Federlassen',
        fr: 'Quand les chocobos voient rouge',
        ja: '豚面と赤い馬鳥',
        cn: '兽性兽心与红色马鸟',
        ko: '시크족과 붉은 초코보',
        tc: '獸性獸心與紅色馬鳥',
      },
      isCEPrecursor: true,
      shortLabel: {
        en: 'Alert',
        de: 'Federlassen',
        fr: 'Chocobos',
        ja: '豚面と赤い馬鳥',
        cn: '兽性兽心与红色马鸟',
        ko: '시크족과 붉은 초코보',
        tc: '獸性獸心與紅色馬鳥',
      },
      x: 27.3,
      y: 17.7,
      fateId: 1608,
    },
    unicorn: {
      label: {
        en: 'Unicorn Flakes',
        de: 'Llofii die Ausgebüxte',
        fr: 'La licorne des plaines',
        ja: '潔白の脱走兵',
        cn: '洁白心的逃脱战',
        ko: '결백한 탈주병',
        tc: '潔白心的逃脫戰',
      },
      isCEPrecursor: true,
      fieldNotes: 13,
      shortLabel: {
        en: 'Unicorn',
        de: 'Llofii',
        fr: 'Licorne',
        ja: '潔白の脱走兵',
        cn: '洁白心的逃脱战',
        ko: '결백한 탈주병',
        tc: '潔白心的逃脫戰',
      },
      x: 32.3,
      y: 17.0,
      fateId: 1609,
    },
    recreation: {
      label: {
        en: 'Parts and Recreation',
        de: 'Aufräumen im Dienst der Wissenschaft',
        fr: 'La bataille de l\'innovation',
        ja: '敵新兵器を調査せよ',
        cn: '调查敌方新兵器',
        ko: '적의 신병기를 조사하라',
        tc: '調查敵方新兵器',
      },
      shortLabel: {
        en: 'Recreation',
        de: 'Aufräumen',
        fr: 'Innovation',
        ja: '敵新兵器を調査せよ',
        cn: '调查敌方新兵器',
        ko: '적의 신병기를 조사하라',
        tc: '調查敵方新兵器',
      },
      x: 25.6,
      y: 22.6,
      fateId: 1610,
    },
    element: {
      label: {
        en: 'The Element of Supplies',
        de: 'Verhinderte Wartung',
        fr: 'Couper les vivres',
        ja: '整備場奇襲作戦',
        cn: '奇袭整备场',
        ko: '정비소 기습 작전',
        tc: '奇襲整備場',
      },
      shortLabel: {
        en: 'Supplies',
        de: 'Wartung',
        fr: 'Vivres',
        ja: '整備場奇襲作戦',
        cn: '奇袭整备场',
        ko: '정비소 기습 작전',
        tc: '奇襲整備場',
      },
      x: 17.5,
      y: 23.4,
      fateId: 1611,
    },
    heavyboots: {
      label: {
        en: 'Heavy Boots of Lead',
        de: 'Gewaltsame Arbeitsniederlegung',
        fr: 'Force ouvrière',
        ja: '魔導レイバー破壊命令',
        cn: '破坏魔导劳工',
        ko: '마도 노동자 파괴 명령',
        tc: '破壞魔導勞工',
      },
      fieldNotes: 15,
      shortLabel: {
        en: 'Boots',
        de: 'Niederlegung',
        fr: 'Force',
        ja: '魔導レイバー破壊命令',
        cn: '破坏魔导劳工',
        ko: '마도 노동자 파괴 명령',
        tc: '破壞魔導勞工',
      },
      x: 31.3,
      y: 22.0,
      fateId: 1612,
    },
    camping: {
      label: {
        en: 'No Camping Allowed',
        de: 'Unfreundlicher Besuch',
        fr: 'Idéaux irréconciliables',
        ja: '野営地への先制攻撃',
        cn: '进攻野营地',
        ko: '야영지 선제 공격',
        tc: '進攻野營地',
      },
      fieldNotes: 6,
      shortLabel: {
        en: 'Camping',
        de: 'Besuch',
        fr: 'Idéaux',
        ja: '野営地への先制攻撃',
        cn: '进攻野营地',
        ko: '야영지 선제 공격',
        tc: '進攻野營地',
      },
      x: 17.5,
      y: 23.4,
      fateId: 1613,
    },
    scavengers: {
      label: {
        en: 'Scavengers of Human Sorrow',
        de: 'Zurück ins Nichts',
        fr: 'Les dévoreurs d\'âmes',
        ja: '魂喰いの妖異たち',
        cn: '噬魂的妖异',
        ko: '혼을 먹는 요마들',
        tc: '噬魂的妖異',
      },
      fieldNotes: 7,
      shortLabel: {
        en: 'Scavengers',
        de: 'Zurück',
        fr: 'Dévoreurs',
        ja: '魂喰いの妖異たち',
        cn: '噬魂的妖异',
        ko: '혼을 먹는 요마들',
        tc: '噬魂的妖異',
      },
      x: 25.6,
      y: 22.6,
      fateId: 1614,
    },
    helpwanted: {
      label: {
        en: 'Help Wanted',
        de: 'Jedes Leben zählt',
        fr: 'Résister ou mourir',
        ja: '術士大隊の猛攻',
        cn: '术师大队的猛攻',
        ko: '술사대대의 맹공격',
        tc: '術師大隊的猛攻',
      },
      shortLabel: {
        en: 'Help',
        de: 'Jedes Leben',
        fr: 'Résister',
        ja: '術士大隊の猛攻',
        cn: '术师大队的猛攻',
        ko: '술사대대의 맹공격',
        tc: '術師大隊的猛攻',
      },
      x: 18.3,
      y: 20.7,
      fateId: 1615,
    },
    pyromancer: {
      label: {
        en: 'Pyromancer Supreme',
        de: 'Der stärkste aller Pyromanten',
        fr: 'Duel brûlant',
        ja: '最強のパイロマンサー',
        cn: '最强的火焰法师',
        ko: '최강의 불꽃술사',
        tc: '最強的火焰法師',
      },
      fieldNotes: 7,
      shortLabel: {
        en: 'Pyromancer',
        de: 'Pyromant',
        fr: 'Brûlant',
        ja: '最強のパイロマンサー',
        cn: '最强的火焰法师',
        ko: '최강의 불꽃술사',
        tc: '最強的火焰法師',
      },
      x: 18.3,
      y: 20.7,
      fateId: 1616,
    },
    rainbow: {
      label: {
        en: 'Waste the Rainbow',
        de: 'Das Ende einer schillernden Karriere',
        fr: 'De toutes les couleurs',
        ja: '華麗なるお気に入り',
        cn: '华丽魔女与心爱珍兽',
        ko: '화려한 애완마수',
        tc: '華麗魔女與心愛珍獸',
      },
      fieldNotes: 13,
      shortLabel: {
        en: 'Rainbow',
        de: 'Karriere',
        fr: 'Couleurs',
        ja: '華麗なるお気に入り',
        cn: '华丽魔女与心爱珍兽',
        ko: '화려한 애완마수',
        tc: '華麗魔女與心愛珍獸',
      },
      x: 25.1,
      y: 15.0,
      fateId: 1617,
    },
    wildbunch: {
      label: {
        en: 'The Wild Bunch',
        de: 'Revierkämpfe',
        fr: 'Sans maîtres ni loi',
        ja: '暴走魔獣の排除',
        cn: '排除失控魔兽',
        ko: '폭주 마수 처리',
        tc: '排除失控魔獸',
      },
      shortLabel: {
        en: 'Wild Bunch',
        de: 'Revierkämpfe',
        fr: 'Sans maîtres',
        ja: '暴走魔獣の排除',
        cn: '排除失控魔兽',
        ko: '폭주 마수 처리',
        tc: '排除失控魔獸',
      },
      x: 21.0,
      y: 14.3,
      fateId: 1618,
    },
    familyotheranimals: {
      label: {
        en: 'My Family and Other Animals',
        de: 'Ein rüpelhaftes Großmaul',
        fr: 'L\'incorruptible',
        ja: '豚面の勧誘者',
        cn: '兽性兽心的劝诱',
        ko: '포섭하는 시크족',
        tc: '獸性獸心的勸誘',
      },
      shortLabel: {
        en: 'Family',
        de: 'Großmaul',
        fr: 'Incorruptible',
        ja: '豚面の勧誘者',
        cn: '兽性兽心的劝诱',
        ko: '포섭하는 시크족',
        tc: '獸性獸心的勸誘',
      },
      x: 11.0,
      y: 14.6,
      fateId: 1619,
    },
    mechanicalman: {
      label: {
        en: 'I\'m a Mechanical Man',
        de: 'Gewaltsame Arbeitsniederlegung - Plan B',
        fr: 'Plan B',
        ja: '魔導レイバーB型破壊命令',
        cn: '破坏魔导劳工B型',
        ko: '마도 노동자 B형 파괴 명령',
        tc: '破壞魔導勞工B型',
      },
      isCEPrecursor: true,
      shortLabel: {
        en: 'Mechanical',
        de: 'Plan B',
        fr: 'Plan B',
        ja: '魔導レイバーB型破壊命令',
        cn: '破坏魔导劳工B型',
        ko: '마도 노동자 B형 파괴 명령',
        tc: '破壞魔導勞工B型',
      },
      x: 20.8,
      y: 17.7,
      fateId: 1620,
    },
    murder: {
      label: {
        en: 'Murder Death Kill',
        de: 'Neu und besser',
        fr: 'Des machines et des hommes',
        ja: '強化兵部隊の襲撃',
        cn: '袭击强化兵部队',
        ko: '강화병 부대의 습격',
        tc: '襲擊強化兵部隊',
      },
      fieldNotes: 11,
      shortLabel: {
        en: 'Murder',
        de: 'Neu und besser',
        fr: 'Des Machines',
        ja: '強化兵部隊の襲撃',
        cn: '袭击强化兵部队',
        ko: '강화병 부대의 습격',
        tc: '襲擊強化兵部隊',
      },
      x: 14.0,
      y: 15.3,
      fateId: 1621,
    },
    seeking: {
      label: {
        en: 'Desperately Seeking Something',
        de: '... fällt selbst hinein',
        fr: 'Ceux qui creusent',
        ja: '戦場の盗掘者',
        cn: '战场的偷盗者',
        ko: '전장의 도굴자',
        tc: '戰場的偷盜者',
      },
      shortLabel: {
        en: 'Seeking',
        de: 'fällt',
        fr: 'Creusent',
        ja: '戦場の盗掘者',
        cn: '战场的偷盗者',
        ko: '전장의 도굴자',
        tc: '戰場的偷盜者',
      },
      x: 24.8,
      y: 17.1,
      fateId: 1622,
    },
    suppliesparty: {
      label: {
        en: 'Supplies Party',
        de: 'Deins wird meins',
        fr: 'Casser la voie',
        ja: '補給物資強奪作戦',
        cn: '补给物资夺取战',
        ko: '보급 물자 강탈 작전',
        tc: '補給物資奪取戰',
      },
      fieldNotes: 5,
      shortLabel: {
        en: 'Supplies',
        de: 'Deins',
        fr: 'Casser',
        ja: '補給物資強奪作戦',
        cn: '补给物资夺取战',
        ko: '보급 물자 강탈 작전',
        tc: '補給物資奪取戰',
      },
      x: 21.0,
      y: 14.3,
      fateId: 1623,
    },
    demonic: {
      label: {
        en: 'Demonstrably Demonic',
        de: 'Der Geruch der Angst',
        fr: 'Par l\'hémoglobine alléchés',
        ja: '血の匂い',
        cn: '闻血而来',
        ko: '피비린내에 이끌려',
        tc: '聞血而來',
      },
      shortLabel: {
        en: 'Demonic',
        de: 'Geruch',
        fr: 'Hémoglobine',
        ja: '血の匂いに誘われて',
        cn: '闻血而来',
        ko: '피비린내에 이끌려',
        tc: '聞血而來',
      },
      x: 11.1,
      y: 20.2,
      fateId: 1624,
    },
    absentfriends: {
      label: {
        en: 'For Absent Friends',
        de: 'Eine neue Unordnung',
        fr: 'Miséricorde vengeresse',
        ja: '燃え上がる南方戦線',
        cn: '南方战线的激战',
        ko: '타오르는 남부 전선',
        tc: '南方戰線的激戰',
      },
      fieldNotes: 12,
      shortLabel: {
        en: 'Absent',
        de: 'Unordnung',
        fr: 'Vengeresse',
        ja: '燃え上がる南方戦線',
        cn: '南方战线的激战',
        ko: '타오르는 남부 전선',
        tc: '南方戰線的激戰',
      },
      isCEPrecursor: true,
      x: 13.8,
      y: 18.3,
      fateId: 1625,
    },
    steelflame: {
      label: {
        en: 'Of Steel and Flame',
        de: 'Auf und ab',
        fr: 'Le fer et le feu',
        ja: '続・燃え上がる南方戦線',
        cn: '南方战线的续战',
        ko: '타오르는 남부 전선 속편',
        tc: '南方戰線的續戰',
      },
      isCEPrecursor: true,
      fieldNotes: 14,
      shortLabel: {
        en: 'Steel',
        de: 'Auf und ab',
        fr: 'Fer & Feu',
        ja: '続・燃え上がる南方戦線',
        cn: '南方战线的续战',
        ko: '타오르는 남부 전선 속편',
        tc: '南方戰線的續戰',
      },
      x: 13.8,
      y: 18.3,
      fateId: 1626,
    },
    dogsofwar: {
      label: {
        en: 'Let Slip the Dogs of War',
        de: 'Vor die Hunde gekommen',
        fr: 'Brigade canine',
        ja: '戦場の犬を解き放て',
        cn: '释放战场之犬',
        ko: '전장에 개를 풀어라',
        tc: '釋放戰場之犬',
      },
      fieldNotes: 4,
      shortLabel: {
        en: 'Dogs',
        de: 'Hunde',
        fr: 'Brigade',
        ja: '戦場の犬を解き放て',
        cn: '释放战场之犬',
        ko: '전장에 개를 풀어라',
        tc: '釋放戰場之犬',
      },
      x: 14.0,
      y: 15.3,
      fateId: 1627,
    },
    warmachines: {
      label: {
        en: 'The War Against the Machine',
        de: 'Ende Gelände',
        fr: 'Cent mille guerriers de métal',
        ja: 'シシニアスの実験場',
        cn: '西西尼乌斯的实验场',
        ko: '시시니우스의 실험장',
        tc: '西西尼烏斯的實驗場',
      },
      fieldNotes: 3,
      shortLabel: {
        en: 'War',
        de: 'Ende Gelände',
        fr: 'Cent Mille',
        ja: 'シシニアスの実験場',
        cn: '西西尼乌斯的实验场',
        ko: '시시니우스의 실험장',
        tc: '西西尼烏斯的實驗場',
      },
      x: 11.1,
      y: 20.2,
      fateId: 1628,
    },
    castrumlacuslitore: {
      label: {
        en: 'Castrum Lacus Litore',
        de: 'Castrum Lacus Litore',
        fr: 'Castrum Lacus Litore',
        ja: 'カストルム',
        cn: '帝国湖岸堡攻城战',
        ko: '카스트룸 라쿠스리토레 공성전',
        tc: '帝國湖岸堡攻城戰',
      },
      shortLabel: {
        en: 'Castrum',
        de: 'Castrum',
        fr: 'Castrum',
        ja: 'カストルム',
        cn: '攻城战',
        ko: '공성전',
        tc: '攻城戰',
      },
      x: 18.9,
      y: 12.6,
      isCritical: true,
      ceKey: 0,
      // TODO: this needs a 60 minute respawn *after* it finishes.
      // respawnMinutes: 60,
    },
    killitwithfire: {
      label: {
        en: 'Kill It With Fire',
        de: 'Peeriefool, das faule Gemüse',
        fr: 'Grandeur et pestilence',
        ja: 'ピーリフール',
        cn: '腐烂蔬菜——皮里福尔',
        ko: '썩은 야채 \'피어리풀\'',
        tc: '腐爛蔬菜——皮裡福爾',
      },
      fieldNotes: 13,
      shortLabel: {
        en: 'Kill it',
        de: 'Peeriefool',
        fr: 'Pestilence',
        ja: 'ピーリフール',
        cn: '皮里福尔',
        ko: '피어리풀',
        tc: '皮裡福爾',
      },
      x: 17.4,
      y: 26.9,
      isCritical: true,
      ceKey: 1,
    },
    bayinghounds: {
      label: {
        en: 'The Baying of the Hound(s)',
        de: 'Die drei Mäuler des Canis dirus',
        fr: 'Le chien des enfers',
        ja: 'カニスディルス',
        cn: '战争妖犬——恐惧妖犬',
        ko: '전쟁 요마견 \'카니스 디루스\'',
        tc: '戰爭妖犬——恐懼妖犬',
      },
      shortLabel: {
        en: 'Hounds',
        de: 'Canis dirus',
        fr: 'Chien',
        ja: 'カニスディルス',
        cn: '恐惧妖犬',
        ko: '카니스 디루스',
        tc: '恐懼妖犬',
      },
      x: 22.8,
      y: 28.8,
      isCritical: true,
      ceKey: 2,
    },
    vigilforthelost: {
      label: {
        en: 'Vigil for the Lost',
        de: 'Vigil, Feuerkraft hoch zehn',
        fr: 'Vigile de feu',
        ja: 'ヴィジル',
        cn: '高火力陆战魔导兵器——守夜',
        ko: '고화력 육지전 마도 병기 \'비질\'',
        tc: '高火力陸戰魔導兵器——守夜',
      },
      shortLabel: {
        en: 'Vigil',
        de: 'Vigil',
        fr: 'Vigile',
        ja: 'ヴィジル',
        cn: '守夜',
        ko: '비질',
        tc: '守夜',
      },
      x: 28.4,
      y: 29.5,
      isCritical: true,
      isDuelPrecursor: true,
      ceKey: 3,
    },
    aceshigh: {
      label: {
        en: 'Aces High',
        de: 'Gabriel, die stählerne Schwinge',
        fr: 'Force divine',
        ja: 'ガブリエル',
        cn: '新型飞行型魔导装甲——加百列',
        ko: '신형 비행 마도 아머 \'가브리엘\'',
        tc: '新型飛行型魔導裝甲——加百列',
      },
      fieldNotes: 11,
      shortLabel: {
        en: 'Aces High',
        de: 'Gabriel',
        fr: 'Force divine',
        ja: 'ガブリエル',
        cn: '加百列',
        ko: '가브리엘',
        tc: '加百列',
      },
      x: 32.3,
      y: 26.8,
      isCritical: true,
      isDuel: true,
      respawnMinutes: 60,
      ceKey: 4,
    },
    shadowdeathshand: {
      label: {
        en: 'The Shadow of Death\'s Hand',
        de: 'Akbaba, Tod von oben',
        fr: 'Les ailes noires de la mort',
        ja: '黒アクババ',
        cn: '黑死鸟——阿克巴巴',
        ko: '죽음의 검은 새 \'아크바바\'',
        tc: '黑死鳥——阿克巴巴',
      },
      fieldNotes: 3,
      shortLabel: {
        en: 'Shadow',
        de: 'Akbaba',
        fr: 'Ailes noires',
        ja: '黒アクババ',
        cn: '阿克巴巴',
        ko: '아크바바',
        tc: '阿克巴巴',
      },
      x: 36.5,
      y: 25.8,
      isCritical: true,
      ceKey: 5,
    },
    finalfurlong: {
      label: {
        en: 'The Final Furlong',
        de: 'Spartoi der Gefürchtete',
        fr: 'Menace spectrale',
        ja: 'スパルトイ',
        cn: '怨念死灵——地生人',
        ko: '원념의 사령 \'스파르토이\'',
        tc: '怨念死靈——地生人',
      },
      fieldNotes: 9,
      shortLabel: {
        en: 'Furlong',
        de: 'Spartoi',
        fr: 'Menace',
        ja: 'スパルトイ',
        cn: '地生人',
        ko: '스파르토이',
        tc: '地生人',
      },
      x: 33.3,
      y: 17.5,
      isCritical: true,
      ceKey: 6,
    },
    choctober: {
      label: {
        en: 'The Hunt for Red Choctober',
        de: 'Der Rote Meteor und seine Meute',
        fr: 'Une ruée en rouge',
        ja: '赤レッドコメット',
        cn: '红陆行鸟之王——红色彗星',
        ko: '우두머리 초코보 \'붉은 혜성\'',
        tc: '紅陸行鳥之王——紅色彗星',
      },
      shortLabel: {
        en: 'Choctober',
        de: 'Roter Meteor',
        fr: 'Ruée en Rouge',
        ja: '赤レッドコメット',
        cn: '红色彗星',
        ko: '붉은 혜성',
        tc: '紅色彗星',
      },
      x: 27.3,
      y: 17.7,
      isCritical: true,
      isDuelPrecursor: true,
      ceKey: 7,
    },
    beastofman: {
      label: {
        en: 'Beast of Man',
        de: 'Lyon der Bestienkönig',
        fr: 'Le Roi bestial',
        ja: '獣王ライアン',
        cn: '百兽之王——兽王莱昂',
        ko: '백수의 왕 \'마수왕 라이언\'',
        tc: '百獸之王——獸王萊昂',
      },
      fieldNotes: 17,
      shortLabel: {
        en: 'Beast of Man',
        de: 'Lyon',
        fr: 'Roi Bestial',
        ja: '獣王ライアン',
        cn: '兽王',
        ko: '마수왕 라이언',
        tc: '獸王',
      },
      x: 23.3,
      y: 20.4,
      isCritical: true,
      isDuel: true,
      respawnMinutes: 60,
      ceKey: 8,
    },
    firesofwar: {
      label: {
        en: 'The Fires of War',
        de: 'Die Flammenden Hundert',
        fr: 'Brasier de guerre',
        ja: '火焔百人隊',
        cn: '炎兽训练师——火焰百夫队',
        ko: '화염마수 조련사 \'화염백인대\'',
        tc: '炎獸訓練師——火焰百夫隊',
      },
      shortLabel: {
        en: 'Fires of War',
        de: 'Flammenden Hundert',
        fr: 'Brasier',
        ja: '火焔百人隊',
        cn: '火焰百夫队',
        ko: '화염백인대',
        tc: '火焰百夫隊',
      },
      x: 20.8,
      y: 23.9,
      isCritical: true,
      ceKey: 9,
    },
    patriotgames: {
      label: {
        en: 'Patriot Games',
        de: 'Verteidigungsmaschine Patriot',
        fr: 'Les fusils du patriote',
        ja: 'パトリオット',
        cn: '据点防卫魔导兵器——爱国者',
        ko: '거점 방위 병기 \'패트리어트\'',
        tc: '據點防衛魔導兵器——愛國者',
      },
      shortLabel: {
        en: 'Patriot',
        de: 'Patriot',
        fr: 'Patriote',
        ja: 'パトリオット',
        cn: '爱国者',
        ko: '패트리어트',
        tc: '愛國者',
      },
      x: 14.2,
      y: 21.2,
      isCritical: true,
      ceKey: 10,
    },
    trampledunderhoof: {
      label: {
        en: 'Trampled under Hoof',
        de: 'Die bösen Blicke der Eale',
        fr: 'L\'œil du malin',
        ja: '邪エアレー',
        cn: '邪眼妖兽——耶鲁',
        ko: '마안의 요수 \'에알레\'',
        tc: '邪眼妖獸——耶魯',
      },
      shortLabel: {
        en: 'Trampled',
        de: 'Eale',
        fr: 'Œil du malin',
        ja: '邪エアレー',
        cn: '耶鲁',
        ko: '에알레',
        tc: '耶魯',
      },
      x: 9.9,
      y: 18.1,
      isCritical: true,
      ceKey: 11,
    },
    flameswenthigher: {
      label: {
        en: 'And the Flames Went Higher',
        de: 'Sartauvoir Eisenfeuer',
        fr: 'L\'envol du phénix',
        ja: 'サルトヴォアール',
        cn: '老练魔法师——铁胆狱火萨托瓦尔',
        ko: '노련한 마도사 \'쇳불의 사르토부아르\'',
        tc: '老練魔法師——鐵膽獄火薩托瓦爾',
      },
      fieldNotes: 14,
      shortLabel: {
        en: 'Flames',
        de: 'Sartauvoir',
        fr: 'Phénix',
        ja: 'サルトヴォアール',
        cn: '铁火',
        ko: '사르토부아르',
        tc: '鐵火',
      },
      x: 18.8,
      y: 15.9,
      isCritical: true,
      isDuel: true,
      respawnMinutes: 60,
      ceKey: 12,
    },
    metalfoxchaos: {
      label: {
        en: 'Metal Fox Chaos',
        de: 'Dáinsleif, Bestie aus Eisen',
        fr: 'Le guerrier de métal',
        ja: 'ダーインスレイヴ',
        cn: '钢铁魔兽——达因斯莱瓦',
        ko: '강철 마수 \'다인슬라이프\'',
        tc: '鋼鐵魔獸——達因斯萊瓦',
      },
      shortLabel: {
        en: 'Metal Fox',
        de: 'Dáinsleif',
        fr: 'Guerrier de Métal',
        ja: 'ダーインスレイヴ',
        cn: '钢铁魔兽',
        ko: '다인슬라이프',
        tc: '鋼鐵魔獸',
      },
      x: 13.8,
      y: 18.3,
      isCritical: true,
      isDuelPrecursor: true,
      ceKey: 13,
    },
    riseoftherobots: {
      label: {
        en: 'Rise of the Robots',
        de: 'Im Schatten von Modell X',
        fr: 'Le soulèvement des machines',
        ja: '魔導レイバーX型',
        cn: '新型铁巨人——魔导劳工X式',
        ko: '새로운 철거인 \'마도 노동자 X형\'',
        tc: '新型鐵巨人——魔導勞工X式',
      },
      fieldNotes: 15,
      shortLabel: {
        en: 'Rise',
        de: 'Modell X',
        fr: 'Soulèvement',
        ja: '魔導レイバーX型',
        cn: '劳动X号',
        ko: '마도 노동자 X형',
        tc: '勞動X號',
      },
      x: 21.2,
      y: 17.6,
      isCritical: true,
      ceKey: 14,
    },
    wherestrodebehemoth: {
      label: {
        en: 'Where Strode the Behemoth',
        de: 'Der untote Chlevnik',
        fr: 'Le mastodonte enragé',
        ja: 'チルヴニク',
        cn: '战栗之角——奇尔维尼克',
        ko: '전율의 뿔 \'칠레브니크\'',
        tc: '戰慄之角——奇爾維尼克',
      },
      shortLabel: {
        en: 'Behemoth',
        de: 'Chlevnik',
        fr: 'Mastodonte',
        ja: 'チルヴニク',
        cn: '贝爷',
        ko: '칠레브니크',
        tc: '貝爺',
      },
      x: 24.2,
      y: 14.9,
      isCritical: true,
      ceKey: 15,
    },
  },
};
